import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

import PageOrganizationsDetailSsoSamlConfigure from 'hcp/components/page/organizations/detail/sso/saml/configure';

<template>
  {{pageTitle (t "page-title.sso.configure")}}

  <BreadcrumbsItem
    @route="cloud.orgs.detail.settings.sso.select-method"
    @text={{t
      "components.page.organizations.sso.select-method.protocol.breadcrumb"
    }}
  />

  <BreadcrumbsItem
    @route="cloud.orgs.detail.settings.sso.saml.configure"
    @text={{t "components.page.organizations.sso.configure.saml.breadcrumb"}}
  />

  <PageOrganizationsDetailSsoSamlConfigure @model={{@controller.model}} />
</template>
